export const basicAuthToken =
  "Basic aWVsdHNfdXNlcjppZWx0c1B3ZDIwMjMjISFATG9jaw=="
